import * as React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { MessageProvider } from "assets/js/syntax";
// import {ModalPlatformContract} from "components/modal/ModalPlatformContract";
import ModalPlatformContract from "components/modal/ModalPlatformContractNew";

function Dev() {
  return (
    <React.StrictMode>
      <MessageProvider>
        <Router>
          <ModalPlatformContract onClose={() => {}} />
        </Router>
      </MessageProvider>
    </React.StrictMode>
  );
}

export default Dev;
